import SplitButton from './SplitButton';
export default SplitButton;
